import { api } from './client';
import type { Page } from './catalogs';

export interface AuditLogRow {
  occurred_at: string;
  user_id: string | null;
  user_email: string | null;
  user_full_name: string | null;
  organization_id: string | null;
  action: string;
  entity_type: string;
  entity_id: string;
  before_data: Record<string, unknown> | null;
  after_data: Record<string, unknown> | null;
}

export const auditLog = {
  list: (params?: {
    entity_type?: string;
    entity_id?: string;
    date_from?: string;
    date_to?: string;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<AuditLogRow>>('/audit-log', { params }).then((r) => r.data),
};
